import { z } from 'zod';
/** OASIS M0010_CCN: exactly 6 alphanumeric characters (A-M0010_CCN-format-3120 / -5280). */
export const PTAN_PATTERN = /^[A-Za-z0-9]{6}$/;
export const PTAN_VALIDATION_MESSAGE = 'Must be exactly 6 letters or numbers';
export const ptanValidationSchema = (requiredMessage = 'Required') => z.string({ message: requiredMessage }).trim().min(1, requiredMessage).regex(PTAN_PATTERN, PTAN_VALIDATION_MESSAGE);
